<div class="search">
  <ui-inline-svg class="search-icon" name="search"></ui-inline-svg>
  <input 
    #inputElement
    class="search-input"
    type="text"
    data-testid="search-input"
    [placeholder]="placeholder() ?? ('COMMON.SEARCH' | transloco)"
    [(ngModel)]="value"
    (keyup.enter)="submitted.emit()"
    (blur)="onBlurEvent($event)"
    (focus)="focus.emit($event)"
    (mousedown)="onTextClick($event)"
    />

    <div class="search-clear" [style.visibility]="value() ? 'visible' : 'hidden'">
      <ui-button-close data-testid="search-clear" (click)="onClickClear($event)"></ui-button-close>
    </div>
</div>
